import { render } from "./IconDotsHorizontal.vue?vue&type=template&id=6c5d16f6"
import script from "./IconDotsHorizontal.vue?vue&type=script&lang=js"
export * from "./IconDotsHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__